import type { Game, AvailableActionOption } from '../../types/game'
import { FlowerCard } from './FlowerCard'
import { Worker } from '../shared/Worker'

interface FlowerMarketProps {
  game: Game
  availableActions: AvailableActionOption[]
  onForage: (flowerId: number) => void
}

export function FlowerMarket({ game, availableActions, onForage }: FlowerMarketProps) {
  return (
    <div className="flower-market tableau">
      <div className="flower-market-token-pool-container">
        <div className="flower-market-title">Forage</div>
        <div className="flower-market-token-pool" data-worker-target="forage-pool">
          {game.foragers.map((color, index) => (
            <Worker key={`${color}-${index}`} color={color} size="1.4em" />
          ))}
        </div>
      </div>

      <div className="flower-pad-container">
        <div className="flower-pad-placeholder">
          {Array.from({ length: game.n_flower_market_slots }).map((_, index) => (
            <div key={`placeholder-${index}`} className="flower-placeholder" />
          ))}
        </div>
        <div className="flower-pad">
          {game.flower_market.map((flower) => (
            <FlowerCard
              key={flower.id}
              flower={flower}
              currentSeason={game.current_season}
              onClick={() => onForage(flower.id)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
